<template>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li 
          v-for="(crumb, index) in crumbs" 
          :key="index" 
          class="breadcrumb-item"
          :class="{ active: index === crumbs.length - 1 }"
          aria-current="page"
        >
          <span v-if="index === crumbs.length - 1">{{ crumb.text }}</span>
          <router-link v-else :to="crumb.path">{{ crumb.text }}</router-link>
        </li>
      </ol>
    </nav>
  </template>
  
  <script>
  export default {
    name: 'BreadcrumbComponent',
    props: {
      crumbs: {
        type: Array,
        required: true,
        default: () => []
      }
    }
  };
  </script>
  
  <style scoped>
  .breadcrumb {
    background-color: transparent;
    padding: 0;
    margin-bottom: 1rem;
  }
  .breadcrumb-item a {
    text-decoration: none;
    color: #3f51b5;
  }
  .breadcrumb-item a:hover {
    text-decoration: underline;
  }
  .breadcrumb-item.active {
    color: #6c757d;
  }
  </style>
  